import {
    PRODUCT_DRAFT_FETCHING,
    PRODUCT_DRAFT_FETCHING_FAILURE,
    PRODUCT_DRAFT_FETCHING_SUCCESS,
} from '../../actions/types'

const INITIAL_STATE = {
    sku: '',
    description: [],
    createdAt: '',
    updatedAt: '',
    fetching: false,
}

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PRODUCT_DRAFT_FETCHING:
            return {
                ...state,
                fetching: true,
            }

        case PRODUCT_DRAFT_FETCHING_SUCCESS:
            if (action.payload.sku === undefined) {
                return {
                    sku: '',
                    description: [],
                    createdAt: '',
                    updatedAt: '',
                    fetching: false,
                }
            }

            return {
                ...state,
                fetching: false,
                sku: action.payload.sku,
                description: action.payload.description,
                createdAt: action.payload.createdAt,
                updatedAt: action.payload.updatedAt,
            }

        case PRODUCT_DRAFT_FETCHING_FAILURE:
            return {
                sku: '',
                description: [],
                createdAt: '',
                updatedAt: '',
                fetching: false,
            }

        default:
            return state
    }
}

export default reducer
